import { render, staticRenderFns } from "./zone-footer-two.vue?vue&type=template&id=5d45017c&scoped=true"
import script from "./zone-footer-two.vue?vue&type=script&lang=js"
export * from "./zone-footer-two.vue?vue&type=script&lang=js"
import style0 from "./zone-footer-two.vue?vue&type=style&index=0&id=5d45017c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d45017c",
  null
  
)

export default component.exports